import * as React from 'react';

const SvgGooglePlay = (props) => (
  <svg
    width={116}
    height={29}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M37.5 4.3c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.4 0 .8.1 1.2.3.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2V4h2.9v.3ZM42.1 1.8h-2.7v1.9h2.5v.7h-2.5v1.9h2.7v.8h-3.5v-6h3.5v.7ZM45.4 7.1h-.8V1.8h-1.7v-.7h4.2v.7h-1.7v5.3ZM50 7.1v-6h.8v6H50ZM54.2 7.1h-.8V1.8h-1.7v-.7h4.1v.7h-1.7v5.3h.1ZM63.7 6.3c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2Zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7ZM65.7 7.1v-6h.9l2.9 4.7V1.1h.8v6h-.8l-3.1-4.9v4.9h-.7Z'
      fill='#fff'
      stroke='#fff'
      strokeWidth={0.2}
      strokeMiterlimit={10}
    />
    <path
      d='M58.2 15.9c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3Zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6Zm-9.3-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3Zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6Zm-11.1-5.5V19h4.3c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8 0-2.7 2.1-4.8 4.7-4.8 1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2Zm45.4 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5ZM77.4 20c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9L77.4 20Zm-4.7 4.1h1.9V11.6h-1.9v12.5Zm-3-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4v-7.6h-1.8v.7Zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6Zm24.4-11.1h-4.5v12.5h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9Zm.1 6h-2.7v-4.3H92c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2Zm11.5-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5Zm-.2 6.9c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2Zm10.5-6.6-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2Zm-16.8 8h1.9V11.6H97v12.5Z'
      fill='#fff'
    />
    <path
      d='M.5 1.6C.2 1.9 0 2.4 0 3v22.1c0 .6.2 1.1.5 1.4l.1.1L13 14.2V14L.5 1.6Z'
      fill='url(#google-play_svg__a)'
    />
    <path
      d='M17.1 18.4 13 14.3V14l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7Z'
      fill='url(#google-play_svg__b)'
    />
    <path
      d='M17.2 18.3 13 14.1.5 26.6c.5.5 1.2.5 2.1.1l14.6-8.4Z'
      fill='url(#google-play_svg__c)'
    />
    <path
      d='M17.2 9.9 2.6 1.6c-.9-.5-1.6-.4-2.1.1L13 14.1l4.2-4.2Z'
      fill='url(#google-play_svg__d)'
    />
    <path
      opacity={0.2}
      d='M17.1 18.2 2.6 26.4c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0l14.5-8.4Z'
      fill='#000'
    />
    <path
      opacity={0.12}
      d='M.5 26.4c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1H.5ZM22.1 15.4l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3Z'
      fill='#000'
    />
    <path
      opacity={0.25}
      d='m2.6 1.7 19.5 11.1c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L2.6 1.6C1.2.8.1 1.5.1 3.1v.1C.1 1.6 1.2.9 2.6 1.7Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='google-play_svg__a'
        x1={11.9}
        y1={2.81}
        x2={-4.883}
        y2={19.592}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00A0FF' />
        <stop offset={0.007} stopColor='#00A1FF' />
        <stop offset={0.26} stopColor='#00BEFF' />
        <stop offset={0.512} stopColor='#00D2FF' />
        <stop offset={0.76} stopColor='#00DFFF' />
        <stop offset={1} stopColor='#00E3FF' />
      </linearGradient>
      <linearGradient
        id='google-play_svg__b'
        x1={23.934}
        y1={14.101}
        x2={-0.262}
        y2={14.101}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFE000' />
        <stop offset={0.409} stopColor='#FFBD00' />
        <stop offset={0.775} stopColor='orange' />
        <stop offset={1} stopColor='#FF9C00' />
      </linearGradient>
      <linearGradient
        id='google-play_svg__c'
        x1={14.927}
        y1={16.396}
        x2={-7.831}
        y2={39.154}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF3A44' />
        <stop offset={1} stopColor='#C31162' />
      </linearGradient>
      <linearGradient
        id='google-play_svg__d'
        x1={-2.603}
        y1={-5.724}
        x2={7.56}
        y2={4.439}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#32A071' />
        <stop offset={0.069} stopColor='#2DA771' />
        <stop offset={0.476} stopColor='#15CF74' />
        <stop offset={0.801} stopColor='#06E775' />
        <stop offset={1} stopColor='#00F076' />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgGooglePlay;
